var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConMarkerImageSrcSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 20C43 29.0601 36.9757 36.7131 28.7143 39.1718C25.8571 40 23 45 23 45C23 45 20.1429 40 17.2857 39.1718C9.02432 36.7131 3 29.0601 3 20C3 8.9543 11.9543 0 23 0C34.0457 0 43 8.9543 43 20Z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 44.0447C22.977 44.0088 22.9531 43.9717 22.9284 43.9337C22.6099 43.4428 22.1543 42.7784 21.6063 42.0861C21.0594 41.3952 20.4134 40.6675 19.713 40.0554C19.0179 39.448 18.2399 38.9282 17.4267 38.6921C9.37234 36.2942 3.5 28.8322 3.5 20C3.5 9.23045 12.2304 0.5 23 0.5C33.7696 0.5 42.5 9.23045 42.5 20C42.5 28.8323 36.6276 36.2942 28.5732 38.6921C27.7601 38.9282 26.982 39.448 26.2871 40.0554C25.5866 40.6675 24.9406 41.3952 24.3937 42.0861C23.8457 42.7784 23.3901 43.4428 23.0716 43.9337C23.0469 43.9717 23.023 44.0088 23 44.0447Z",
    stroke: "#FF4848"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.438 11.5208H28.7297V20.4583C28.7297 22.8631 26.7803 24.8125 24.3755 24.8125H19.7922C17.3875 24.8125 15.438 22.8631 15.438 20.4583V11.5208ZM16.813 12.8958V20.4583C16.813 22.1037 18.1468 23.4375 19.7922 23.4375H24.3755C26.0209 23.4375 27.3547 22.1037 27.3547 20.4583V12.8958H16.813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3339 12.8958H28.7297V11.5208H30.3339C31.473 11.5208 32.3964 12.4442 32.3964 13.5833V16.3333C32.3964 17.4724 31.473 18.3958 30.3339 18.3958H28.7297V17.0208H30.3339C30.7136 17.0208 31.0214 16.713 31.0214 16.3333V13.5833C31.0214 13.2036 30.7136 12.8958 30.3339 12.8958Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3339 28.0208H13.8339V26.6458H30.3339V28.0208Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2869",
    x: 0,
    y: 0,
    width: 46,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2869",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConMarkerImageSrcSelect);
export default __webpack_public_path__ + "static/media/conMarkerImageSrc_select.78d8836a7edc8fffae23070c064c61e2.svg";
export { ForwardRef as ReactComponent };